<template>
	<div 
		class="modal custom-modal fade" 
		:id="rel + '-delete-modal'" 
		role="dialog" 
		aria-labelledby="delete-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="closeModal">
                        <i class="fa fa-close"></i>
                    </button>

                    <h4 class="modal-title"><slot name="title"></slot></h4>
                </div>

                <form id="delete-modal-form" role="form" @submit.prevent="deleteResource">
                	<div class="modal-body">
                    	<div class="row">
                    		<div class="col-xs-12 col-sm-12 col-md-12 margin-top-bottom">
								<slot name="message"></slot>
							</div>
						</div>
					</div>

	                <div class="text-center">
	                    <button type="submit" class="btn btn-success btn-fill">Yes</button>
	                    <button type="button" class="btn btn-danger btn-fill" data-dismiss="modal" @click="closeModal">No</button>
	                </div>
	            </form>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		props: ['isOpenModal', 'resourceId', 'rel'],

		watch: {
			isOpenModal(value) {				
				if (value) {
					this.openModal();
				} else {
					this.closeModal();
				}
			}
		},

		methods: {
			openModal() {
				// Use this code to remove duplicates
				$(`div[id=${this.rel}-delete-modal]`).not(':last-child').remove();

				$(`#${this.rel}-delete-modal`).appendTo('body').modal({
					backdrop: 'static'
				});
			},

			closeModal() {
				$(`#${this.rel}-delete-modal`).modal('hide');
				this.$emit('modalClosed');
			},

			deleteResource() {
				this.$emit('deletionConfirmed', this.resourceId);
				this.closeModal();
			}
		},
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// DeleteModal.vue?44eabcfb